// import React from 'react';
// import clsx from 'clsx';
// import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

// import { Button } from '@material-ui/core';

// import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';

// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     button: {
//       background: theme.brand,
//       marginRight: '10px',
//       color: 'white',
//       '&:hover': {
//         background: '#600101',
//       },
//     },
//   })
// );

// export default function EndCallButton(props: { className?: string }) {
//   const classes = useStyles();
//   const { room } = useVideoContext();

//   const disconnectbutton = localStorage.getItem('disconnectbutton') || 'Disconnect';

//   const handleEndCall = async () => {
//     try {
//       const queryParams = new URLSearchParams(window.location.search);
//       const uid = queryParams.get('uid');

//       if (uid) {
//         const fullAPI = '//coachnhsapiv2.goqii.com/twillio/end_call?' + 'uuid=' + uid;

//         await fetch(fullAPI)
//           .then(res => res.json())
//           .then(booksList => {
//             console.log('Disconnect API called successfully:', booksList);
//           })
//           .catch(console.log);
//       }
//     } catch (error) {
//       console.error('Error calling disconnect API:', error);
//     } finally {
//       // Disconnect the room regardless of API call success/failure
//       room!.disconnect();
//     }
//   };

//   return (
//     <Button onClick={handleEndCall} className={clsx(classes.button, props.className)} data-cy-disconnect>
//       {disconnectbutton}
//     </Button>
//   );
// }

import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
  Snackbar,
} from '@material-ui/core';

import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import { useHeidiTranscription } from '../../../hooks/useHeidiTranscription/useHeidiTranscription';
import { heidiApiService } from '../../../services/heidiApi';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      background: (theme as any).brand || theme.palette.primary.main,
      marginRight: '10px',
      color: 'white',
      '&:hover': {
        background: '#600101',
      },
    },
    dialogActions: {
      padding: '16px 24px',
    },
    confirmButton: {
      background: '#d32f2f',
      color: 'white',
      '&:hover': {
        background: '#b71c1c',
      },
    },
    cancelButton: {
      marginRight: '8px',
    },
    processingContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '24px',
      gap: '16px',
    },
    processingText: {
      fontSize: '14px',
      color: '#666',
    },
  })
);

export default function EndCallButton(props: { className?: string }) {
  const classes = useStyles();
  const { room } = useVideoContext();
  const location = useLocation();
  const [transcriptExpanded, setTranscriptExpanded] = useState(false);
  const [transcriptVisible, setTranscriptVisible] = useState(true);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [showProcessingDialog, setShowProcessingDialog] = useState(false);
  const [processingMessage, setProcessingMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [finalTranscriptData, setFinalTranscriptData] = useState<any>(null);
  const [isGeneratingTranscript, setIsGeneratingTranscript] = useState(false);
  const [transcriptError, setTranscriptError] = useState<string | null>(null);
  const [showFinalConfirm, setShowFinalConfirm] = useState(false);

  const {
    isRecording,
    isProcessing,
    liveTranscript,
    consultNote,
    error,
    startRecording,
    stopRecording,
    generateNote,
    getTemplates,
    reset,
  } = useHeidiTranscription();

  const isHeidiEnabled = localStorage.getItem('adhd') === 'Y';

  const disconnectbutton = localStorage.getItem('disconnectbutton') || 'Disconnect';
  const guestDisconnect = location.pathname.startsWith('/guest');
  const disconnectbuttonconfirmation =
    localStorage.getItem('disconnectbuttonconfirmation') || 'Are you sure you want to disconnect this call?';

  const handleHeidiWorkflow = async () => {
    try {
      setIsGeneratingTranscript(true);
      setTranscriptError(null);

      // 1. Stop recording and poll for the consult note
      const resultData = await stopRecording();
      setFinalTranscriptData(resultData);
      const sessionId = heidiApiService.getSessionId();

      // 2. Prepare the combined note content
      const noteContent = [
        resultData?.liveTranscript || liveTranscript
          ? `**Live Transcript:**\n${resultData?.liveTranscript || liveTranscript}\n\n`
          : '',
        resultData?.consultNote?.content ? `**Clinical Note:**\n${resultData.consultNote.content}\n\n` : '',
        resultData?.consultNote?.summary ? `**Summary:**\n${resultData.consultNote.summary}` : '',
      ]
        .filter(Boolean)
        .join('');

      // 3. Save to backend automatically
      const queryParams = new URLSearchParams(window.location.search);
      const uid = queryParams.get('uid');
      if (uid && noteContent) {
        await fetch(`${process.env.REACT_APP_ENDPOINT}/twillio/save_doctor_note`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            appointmentId: uid,
            noteTitle: 'AI-Generated Consultation Note',
            noteBody: noteContent,
          }),
        });
      }

      // 4. FIX: Send session ID and notes to parent via postMessage
      if (window.parent && sessionId) {
        const parentOrigin = process.env.REACT_APP_PARENT_ORIGIN || window.location.origin;
        window.parent.postMessage(
          {
            type: 'HEIDI_SESSION_DATA',
            sessionId: sessionId,
            recordingId: sessionId,
            liveTranscript: resultData?.liveTranscript || liveTranscript || '',
            formattedNote: resultData?.consultNote || null,
          },
          parentOrigin
        );
        console.log('📤 Sent Heidi data to parent domain');
      }

      setIsGeneratingTranscript(false);
      setShowFinalConfirm(true);
    } catch (error) {
      console.error('Error in Heidi workflow:', error);
      setIsGeneratingTranscript(false);
      setTranscriptError('Heidi AI encountered an error. You can still disconnect manually.');
    }
  };

  const handleEndCall = async () => {
    try {
      const queryParams = new URLSearchParams(window.location.search);
      const uid = queryParams.get('uid');

      if (uid) {
        const fullAPI = `${process.env.REACT_APP_ENDPOINT}/twillio/end_call?uuid=${uid}`;

        await fetch(fullAPI)
          .then(res => res.json())
          .then(booksList => {
            console.log('Disconnect API called successfully:', booksList);
          })
          .then(() => {
            if (room) {
              room.disconnect();
            }
          })
          .catch(console.error);
      }

      setShowConfirmDialog(false);
      reset();
    } catch (error) {
      console.error('Error calling disconnect API:', error);
    }
  };

  const handleJoinLater = () => {
    if (room) {
      room.disconnect();
    }
    setShowConfirmDialog(false);
  };

  const handleDisconnectClick = () => {
    setShowConfirmDialog(true);
  };

  const handleConfirmDisconnect = () => {
    if (isHeidiEnabled && isRecording) {
      handleHeidiWorkflow(); // This now handles processing -> saving -> postMessage -> showing review
    } else {
      handleEndCall();
    }
  };

  const handleFinalFinish = () => {
    // Logic once the user clicks the final "Finish & Disconnect" button
    setShowConfirmDialog(false);
    handleEndCall();
  };

  const handleFinalDisconnect = async () => {
    // User reviewed transcript, now actually disconnect
    setShowConfirmDialog(false);
    setShowProcessingDialog(true);
    setProcessingMessage('Saving consultation notes...');

    const queryParams = new URLSearchParams(window.location.search);
    const uid = queryParams.get('uid');
    const sessionId = heidiApiService.getSessionId();

    // Prepare combined note content
    const noteContent = [
      finalTranscriptData?.liveTranscript || liveTranscript
        ? `**Live Transcript:**\n${finalTranscriptData?.liveTranscript || liveTranscript}\n\n`
        : '',
      finalTranscriptData?.consultNote?.content
        ? `**Clinical Note:**\n${finalTranscriptData.consultNote.content}\n\n`
        : '',
      finalTranscriptData?.consultNote?.summary ? `**Summary:**\n${finalTranscriptData.consultNote.summary}` : '',
    ]
      .filter(Boolean)
      .join('');

    // Save to clinicdashboard notes BEFORE disconnecting
    if (uid && noteContent) {
      try {
        console.log('💾 Saving AI transcript to notes...');
        const saveResponse = await fetch(`${process.env.REACT_APP_ENDPOINT}/twillio/save_doctor_note`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            appointmentId: uid,
            noteTitle: 'AI-Generated Consultation Note',
            noteBody: noteContent,
          }),
        });
        if (saveResponse.ok) {
          console.log('✅ Notes saved to clinicdashboard');
        }
      } catch (error) {
        console.error('⚠️ Failed to save notes:', error);
      }
    }

    // Send session ID and notes to parent via postMessage
    if (window.parent && sessionId) {
      const parentOrigin = process.env.REACT_APP_PARENT_ORIGIN || window.location.origin;
      window.parent.postMessage(
        {
          type: 'HEIDI_SESSION_DATA',
          sessionId: sessionId,
          recordingId: heidiApiService.getSessionId(),
          liveTranscript: finalTranscriptData?.liveTranscript || liveTranscript || '',
          formattedNote: finalTranscriptData?.consultNote || null,
        },
        parentOrigin
      );
      console.log('📤 Sent Heidi data to parent');
    }

    setProcessingMessage('Disconnecting...');
    setTimeout(() => {
      setShowProcessingDialog(false);
      handleEndCall();
    }, 500);
  };

  const handleCancelDisconnect = () => {
    setShowConfirmDialog(false);
    setFinalTranscriptData(null);
    setIsGeneratingTranscript(false);
    setTranscriptError(null);
    setShowFinalConfirm(false);
  };

  useEffect(() => {
    if (isHeidiEnabled && room && !isRecording) {
      // Auto-start recording when room is connected and Heidi is enabled
      const queryParams = new URLSearchParams(window.location.search);
      const uid = queryParams.get('uid') || 'default-user';
      const email = localStorage.getItem('userEmail') || 'user@example.com';

      console.log('🎤 Starting Heidi recording with:', { email, uid, isHeidiEnabled });

      startRecording(email, uid).catch(error => {
        console.error('Failed to start Heidi recording:', error);
      });
    }
  }, [room, isHeidiEnabled, isRecording, startRecording]);

  useEffect(() => {
    if (error) {
      setSnackbarMessage(error);
      setSnackbarOpen(true);
    }
  }, [error]);

  return (
    <>
      {/* Floating "Show Transcript" pill — only rendered when panel is hidden */}
      {/* TODO: re-enable live transcript UI based on condition */}
      {false && isHeidiEnabled && !transcriptVisible && (
        <button
          onClick={() => setTranscriptVisible(true)}
          title="Show transcript"
          style={{
            position: 'fixed',
            bottom: '78px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1001,
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '5px 14px 5px 10px',
            borderRadius: '20px',
            border: '1px solid rgba(255,255,255,0.18)',
            backgroundColor: 'rgba(10,14,12,0.6)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            cursor: 'pointer',
            outline: 'none',
            boxShadow: '0 2px 12px rgba(0,0,0,0.35)',
            transition: 'transform 0.15s ease',
            animation: 'fadeSlideUp 0.2s ease',
          }}
          onMouseEnter={e => (e.currentTarget.style.transform = 'translateX(-50%) scale(1.05)')}
          onMouseLeave={e => (e.currentTarget.style.transform = 'translateX(-50%) scale(1)')}
        >
          <span
            style={{
              width: '7px',
              height: '7px',
              borderRadius: '50%',
              flexShrink: 0,
              backgroundColor: isRecording ? '#22c55e' : 'rgba(255,255,255,0.35)',
              boxShadow: isRecording ? '0 0 5px #22c55e' : 'none',
              animation: isRecording ? 'micPulse 1.8s ease-in-out infinite' : 'none',
            }}
          />
          <span
            style={{
              color: 'rgba(255,255,255,0.82)',
              fontSize: '11px',
              fontWeight: 600,
              letterSpacing: '0.04em',
              whiteSpace: 'nowrap',
            }}
          >
            Show Transcript
          </span>
        </button>
      )}

      {/* Live Transcript Panel */}
      {/* TODO: re-enable live transcript UI based on condition */}
      {false && isHeidiEnabled && transcriptVisible && (
        <div
          style={{
            position: 'fixed',
            bottom: '72px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '92%',
            maxWidth: '820px',
            zIndex: 1000,
            backgroundColor: 'rgba(10, 14, 12, 0.45)',
            backdropFilter: 'blur(18px) saturate(160%)',
            WebkitBackdropFilter: 'blur(18px) saturate(160%)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '14px',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '0 8px 32px rgba(0,0,0,0.35)',
            animation: 'fadeSlideUp 0.2s ease',
          }}
        >
          {/* ── Header bar ── */}
          <div
            onClick={() => setTranscriptExpanded(prev => !prev)}
            style={{
              padding: '7px 14px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              cursor: 'pointer',
              userSelect: 'none',
              flexShrink: 0,
              borderBottom: transcriptExpanded ? '1px solid rgba(255,255,255,0.08)' : 'none',
            }}
          >
            {/* mic dot */}
            <span
              style={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: isRecording ? '#22c55e' : 'rgba(255,255,255,0.3)',
                flexShrink: 0,
                boxShadow: isRecording ? '0 0 6px #22c55e' : 'none',
                animation: isRecording ? 'micPulse 1.8s ease-in-out infinite' : 'none',
              }}
            />
            <span
              style={{ color: 'rgba(255,255,255,0.85)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.04em' }}
            >
              LIVE TRANSCRIPT
            </span>
            {isRecording && (
              <span
                style={{
                  fontSize: '9px',
                  padding: '2px 7px',
                  borderRadius: '20px',
                  backgroundColor: 'rgba(239,68,68,0.85)',
                  color: 'white',
                  fontWeight: 700,
                  letterSpacing: '0.06em',
                  animation: 'pulse 2s infinite',
                }}
              >
                LIVE
              </span>
            )}
            {/* right-side controls */}
            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '4px' }}>
              {/* expand / collapse chevron */}
              <span
                style={{
                  color: 'rgba(255,255,255,0.5)',
                  fontSize: '11px',
                  display: 'inline-block',
                  transform: transcriptExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.25s ease',
                  padding: '2px 6px',
                }}
              >
                ▲
              </span>

              {/* hide button — stops click from bubbling to expand toggle */}
              <span
                onClick={e => {
                  e.stopPropagation();
                  setTranscriptVisible(false);
                }}
                title="Hide transcript"
                style={{
                  color: 'rgba(255,255,255,0.45)',
                  fontSize: '15px',
                  lineHeight: 1,
                  padding: '2px 4px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  transition: 'color 0.15s ease',
                }}
                onMouseEnter={e => ((e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.9)')}
                onMouseLeave={e => ((e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.45)')}
              >
                ✕
              </span>
            </div>
          </div>

          {/* ── Collapsed: subtitle strip (last ~18 words, 2-line max) ── */}
          {!transcriptExpanded && (
            <div
              style={{
                padding: '6px 16px 10px',
                fontSize: '15px',
                fontWeight: 500,
                lineHeight: '1.55',
                color: 'rgba(255,255,255,0.92)',
                textShadow: '0 1px 4px rgba(0,0,0,0.6)',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                wordBreak: 'break-word',
              }}
            >
              {liveTranscript ? (
                liveTranscript
                  .trim()
                  .split(/\s+/)
                  .slice(-18)
                  .join(' ')
              ) : (
                <span style={{ color: 'rgba(255,255,255,0.35)', fontStyle: 'italic', fontSize: '13px' }}>
                  Waiting for speech…
                </span>
              )}
            </div>
          )}

          {/* ── Expanded: full scrollable transcript ── */}
          {transcriptExpanded && (
            <div
              style={{
                maxHeight: '200px',
                overflowY: 'auto',
                padding: '10px 16px 14px',
                fontSize: '14px',
                lineHeight: '1.7',
                color: 'rgba(255,255,255,0.88)',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                maskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 88%, transparent 100%)',
                WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 88%, transparent 100%)',
              }}
            >
              {liveTranscript || (
                <span style={{ color: 'rgba(255,255,255,0.35)', fontStyle: 'italic' }}>Waiting for speech…</span>
              )}
            </div>
          )}
        </div>
      )}

      <Button onClick={handleDisconnectClick} className={clsx(classes.button, props.className)} data-cy-disconnect>
        {guestDisconnect ? 'Disconnect' : disconnectbutton}
      </Button>

      <Dialog
        open={showConfirmDialog}
        onClose={isGeneratingTranscript ? undefined : handleCancelDisconnect} // Prevent closing while processing
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {isGeneratingTranscript
            ? 'Processing Consultation Notes'
            : showFinalConfirm
            ? 'Review Clinical Notes'
            : 'Confirm Disconnect'}
        </DialogTitle>

        <DialogContent>
          {/* VIEW 1: Initial Confirmation */}
          {!isGeneratingTranscript && !showFinalConfirm && !transcriptError && (
            <DialogContentText>{disconnectbuttonconfirmation}</DialogContentText>
          )}

          {/* VIEW 2: Processing (Loading State) */}
          {isGeneratingTranscript && (
            <div className={classes.processingContainer}>
              <CircularProgress size={60} thickness={4} />
              <div style={{ textAlign: 'center' }}>
                <p style={{ fontWeight: 'bold', margin: '10px 0' }}>Generating AI Summary...</p>
                <p className={classes.processingText}>
                  We are analyzing the transcript and formatting your clinical notes. This usually takes 30-60 seconds.
                </p>
              </div>
            </div>
          )}

          {/* VIEW 3: Review Results */}
          {showFinalConfirm && (
            <div
              style={{
                marginTop: '12px',
                maxHeight: '50vh',
                overflowY: 'auto',
                padding: '12px',
                backgroundColor: '#f9f9f9',
                borderRadius: '8px',
                border: '1px solid #eee',
              }}
            >
              {finalTranscriptData?.consultNote?.content ? (
                <>
                  <strong style={{ color: '#2e7d32' }}>🏥 Generated Clinical Note</strong>
                  <pre style={{ whiteSpace: 'pre-wrap', fontSize: '13px', marginTop: '10px', fontFamily: 'inherit' }}>
                    {finalTranscriptData.consultNote.content}
                  </pre>
                </>
              ) : (
                <p>Notes generated and saved successfully. You may now disconnect.</p>
              )}
            </div>
          )}

          {/* VIEW 4: Error State */}
          {transcriptError && (
            <div style={{ padding: '16px', backgroundColor: '#fff5f5', color: '#c53030', borderRadius: '8px' }}>
              <strong>⚠️ Error:</strong> {transcriptError}
            </div>
          )}
        </DialogContent>

        <DialogActions className={classes.dialogActions}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <div>
              {localStorage.getItem('adhd') === 'Y' && !showFinalConfirm && !isGeneratingTranscript && (
                <Button
                  onClick={handleJoinLater}
                  color="primary"
                  style={{ border: '1px solid #1976d2', color: '#1976d2' }}
                  className={classes.cancelButton}
                >
                  Join Later
                </Button>
              )}
            </div>
            {!isGeneratingTranscript && (
              <div style={{ display: 'flex', gap: '8px' }}>
                <Button onClick={handleCancelDisconnect} color="primary" className={classes.cancelButton}>
                  {showFinalConfirm ? 'Back to Call' : 'No'}
                </Button>
                <Button
                  onClick={showFinalConfirm || transcriptError ? handleFinalFinish : handleConfirmDisconnect}
                  className={classes.confirmButton}
                  variant="contained"
                  autoFocus
                >
                  {showFinalConfirm ? 'Finish & Disconnect' : 'Yes, End Call'}
                </Button>
              </div>
            )}
          </div>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showProcessingDialog}
        aria-labelledby="processing-dialog-title"
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogContent>
          <div className={classes.processingContainer}>
            <CircularProgress size={48} />
            <div className={classes.processingText}>{processingMessage}</div>
          </div>
        </DialogContent>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
        @keyframes micPulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.6; transform: scale(0.75); }
        }
        @keyframes fadeSlideUp {
          from { opacity: 0; transform: translateX(-50%) translateY(8px); }
          to   { opacity: 1; transform: translateX(-50%) translateY(0); }
        }
      `}</style>
    </>
  );
}
